import React from "react"
import { twMerge } from "tailwind-merge"

import HealMeTooltip from "./HealMeTooltip"
import { Label } from "./Inputs"

export const Radio = ({ className, ...rest }) => (
  <input className={twMerge("size-6 cursor-pointer accent-gray outline-none", className)} type="radio" {...rest} />
)

export const RadioWithLabel = ({ id, label, checked, disabledTooltipMessage, tooltipMessage, className, ...rest }) => {
  id ||= "radio-" + label.toLowerCase().replace(" ", "-")
  const helpTooltipId = `${id}-help`
  const showDisabledTooltip = rest.disabled && disabledTooltipMessage
  const showHelpTooltip = tooltipMessage && !showDisabledTooltip

  return (
    <div
      className={twMerge("flex items-center", className)}
      data-tooltip-id={showDisabledTooltip ? id : showHelpTooltip ? helpTooltipId : undefined}>
      <Radio id={id} {...rest} checked={checked} className={`flex-none ${checked ? "accent-gray-dark" : ""}`} />
      <Label className={twMerge("mb-0 truncate pl-2 text-base", checked ? "" : "font-normal")} htmlFor={id}>
        {label}
      </Label>
      {showDisabledTooltip && <HealMeTooltip id={id} place="bottom" content={disabledTooltipMessage} />}
      {showHelpTooltip && <HealMeTooltip id={helpTooltipId} place="bottom" content={tooltipMessage} />}
    </div>
  )
}
